import { create } from "zustand";
import { Year } from "@services/api/years/year.types";

type YearStore = {
  visibleYears: Year[];
  setVisibleYears: (years: Year[] | undefined) => void;
  currentYear?: Year;
  setCurrentYear: (year?: Year) => void;
  getYearByExternalId: (externalId?: string) => Year | undefined;
  isYearVisible: (yearExternalId?: string) => boolean;
};

const useYearStore = create<YearStore>((set, get) => ({
  visibleYears: [],
  setVisibleYears: (visibleYears) => {
    set({ visibleYears: visibleYears });
    if (get().currentYear === undefined && visibleYears?.length) {
      set({ currentYear: visibleYears[0] });
    }
  },

  currentYear: undefined,
  setCurrentYear: (year) => set({ currentYear: year }),

  getYearByExternalId: (externalId) =>
    get().visibleYears?.find((year) => year.externalId === externalId) ||
    undefined,

  isYearVisible: (yearExternalId) => {
    const year = get().getYearByExternalId(yearExternalId);
    return year !== undefined && get().visibleYears.includes(year);
  }
}));

export default useYearStore;
